import { type FC } from 'react';


import { type IconProps } from './types';

export const ArrowsPayments4V4Icon: FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 34H30V64" stroke="#FFDD00" strokeWidth="2" />
      <path d="M64 30H34V0" stroke="#FFDD00" strokeWidth="2" />
    </svg>
  );
};

